// Generated by scripts/extract-sheep-sprites.cjs; source atlas files are unchanged.
import image0 from './individual/block_10.png';
import image1 from './individual/block_2.png';
import image2 from './individual/block_1.png';
import image3 from './individual/block_3.png';
import image4 from './individual/block_8.png';
import image5 from './individual/block_11.png';
import image6 from './individual/block_13.png';
import image7 from './individual/block_12.png';
import image8 from './individual/block_bg.png';
import image9 from './individual/block_4.png';
import image10 from './individual/block_7.png';
import image11 from './individual/block_16.png';
import image12 from './individual/block_6.png';
import image13 from './individual/block_5.png';
import image14 from './individual/block_9.png';
import image15 from './individual/block_15.png';
import image16 from './individual/block_14.png';
import image17 from './individual/Skill_ShiftOut1.png';
import image18 from './individual/Skill_Revocation1.png';
import image19 from './individual/Skill_Random1.png';
import image20 from './individual/sp_setting.png';
import image21 from './individual/sp_logo.png';
import image22 from './individual/begin_game_desc.png';
import image23 from './individual/share_game_desc.png';

export const SHEEP_IMAGES: Record<string, { src: string; width: number; height: number }> = {
  'block_10': { src: image0, width: 66, height: 100 },
  'block_2': { src: image1, width: 96, height: 96 },
  'block_1': { src: image2, width: 102, height: 93 },
  'block_3': { src: image3, width: 95, height: 97 },
  'block_8': { src: image4, width: 98, height: 99 },
  'block_11': { src: image5, width: 100, height: 99 },
  'block_13': { src: image6, width: 100, height: 90 },
  'block_12': { src: image7, width: 92, height: 104 },
  'block_bg': { src: image8, width: 120, height: 135 },
  'block_4': { src: image9, width: 102, height: 91 },
  'block_7': { src: image10, width: 98, height: 100 },
  'block_16': { src: image11, width: 78, height: 108 },
  'block_6': { src: image12, width: 91, height: 100 },
  'block_5': { src: image13, width: 96, height: 103 },
  'block_9': { src: image14, width: 98, height: 101 },
  'block_15': { src: image15, width: 97, height: 96 },
  'block_14': { src: image16, width: 90, height: 109 },
  'Skill_ShiftOut1': { src: image17, width: 119, height: 137 },
  'Skill_Revocation1': { src: image18, width: 117, height: 129 },
  'Skill_Random1': { src: image19, width: 118, height: 139 },
  'sp_setting': { src: image20, width: 73, height: 77 },
  'sp_logo': { src: image21, width: 622, height: 185 },
  'begin_game_desc': { src: image22, width: 376, height: 240 },
  'share_game_desc': { src: image23, width: 298, height: 218 }
};
